<template>
  <div class="animated fadeIn">
      <component-header
      title="Customer Details"
       @search-query="val => (filter = val)"
      :hasSearch="true"
      :hasReload="false"
      :hasClear="false"
      :hasCreate="false"
      :hasRadio="false"
    />
    <div>
      <b-row>
        <b-col sm="12">
          <div>
            <b-table
              :fields="customerColumns"
              :dark="false"
              :filter="filter"
              :hover="true"
              thead-class="header"
              :striped="false"
              :bordered="true"
              :current-page="currentPage"
              :per-page="perPage"
              :small="false"
              show-empty
              :fixed="false"
              :items="partnerCustomer"
              @filtered="onFilter"
              responsive="sm"
            >
              <template slot="action" slot-scope="data">
                <b-button
                  size="sm"
                  class="mr-2"
                  variant="primary"
                  @click="viewCustomer(data.item)"
                >
                  <i class="fa fa-eye"></i>
                </b-button>
              </template>
            </b-table>
            <b-row class="mx-0 justify-content-center p-3">
              <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="filterCount"
                aria-controls="my-table"
                prev-text="Prev"
                next-text="Next"
                hide-goto-end-buttons
              ></b-pagination>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import ComponentHeader from "@/components/componentHeader";
import moment from "moment";
import detailView from "@/views/manageOwnCustomer/DetailView";
export default {
  name: "Customer-Details",
  components: {
    detailView,
    ComponentHeader
  },
  data() {
    return {
      filterCount: 0,
      loading: false,
      currentPage: 1,
      filter: "",
      perPage: 9,
      partnerCustomers: {},
      customerColumns: [
        {
          key: "CustomerNo",
          label: "Customer No",
          sortable: true,
        },
        {
          key: "customerName",
          label: "Customer Name",
        },
        {
          key: "service",
          label: "Service",
          sortable: true,
        },
        {
          key: "customerPhone",
          label: "Customer Phone",
        },
        {
          key: "createdDate",
          label: "Create Date",
        },
        {
          key: "action",
          label: "Action",
        },
      ],
    };
  },
  computed: {
    partnerCustomer() {
      let data = this.$store.getters["partner/GetPartnerCustomerList"];
      let customerList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          let arrayObj = {
            _id: obj._id,
            CustomerNo: obj.customerNo,
            customerName: obj.customerName,
            createdDate: this.getProperDate(obj.createdAt),
            service: obj.serviceType,
            customerPhone: obj.phone,
            email: obj.email,
            ...obj,
          };
          customerList.push(arrayObj);
        });
        return customerList;
      } else {
        this.loading = false;
        return [];
      }
    },
  },
  methods: {
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
    async getCustomerList() {
      this.loading = true;
      let payload = {
        customerName: "",
        email: "",
        phone: "",
        serviceId: "",
        customerNo: "",
        MSO: "",
        serviceType: "",
      };
      const data = await this.$store
        .dispatch("partner/fetchPartnerCustomerList", payload)
        .then((data) => {
          if (data.message) {
            this.$toasted.error(data.message);
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getProperDate(data) {
      if (data != null) {
        let date = new Date(data);

        return moment(String(date)).format("DD/MM/YYYY");
      } else {
        return "Unavailable";
      }
    },
     viewCustomer(data) {
      this.$router.push({ name: "DetailView", params: { userData: data } });
    },
  },
  async mounted() {
    this.getCustomerList();
    const customerList = this.$store.getters["partner/GetPartnerCustomerList"];
    if (!customerList || !customerList.length) {
      this.getCustomerList();
    }
  },
};
</script>
